<div class="shared-recipient-menu">
  @if (showRecipientDetails) {
  <div class="menu-wrapper">
    <div class="header">
      <span
        >Order shared by <b>{{ sharedByName }}</b> on {{ dateShared }}</span
      >
    </div>
    <mat-divider class="divider"></mat-divider>
    <div #content class="content">
      @for (sharedRecipient of displayedMembers; track sharedRecipient) {
      <div class="member-content">
        {{ sharedRecipient.memberName }} ({{ sharedRecipient.memberCity }}) @for
        (contact of getVisibleContacts(sharedRecipient?.contacts); track
        contact) {
        <div class="contact-content">
          <mat-icon class="material-icons-outlined">arrow_downward</mat-icon
          ><span>{{ contact.contactName }}</span>
        </div>
        } @if (getExtraContactsCount(sharedRecipient?.contacts) > 0) {
        <div class="contact-content">
          <mat-icon class="material-icons-outlined">arrow_downward</mat-icon
          ><span
            >+{{ getExtraContactsCount(sharedRecipient?.contacts) }} more at
            this firm</span
          >
        </div>
        }
      </div>
      }
    </div>
    @if (hasOverflow) {
    <div class="footer">
      <span
        >Click
        <mat-icon class="material-icons-outlined">share</mat-icon>
        to view all <b>{{ contactsCount }}</b> recipients across
        <b>{{ membersCount }}</b> firms</span
      >
    </div>
    }
  </div>
  } @else {
  <div class="plain-tool-tip">
    <span>Share all results from this order</span>
  </div>
  }
</div>
